import { Component } from '@theme/component';
import { fetchConfig, onAnimationEnd, preloadImage } from '@theme/utilities';
import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from '@theme/events';
import { cartPerformance } from '@theme/performance';
import { morph } from '@theme/morph';

export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;

/**
 * A custom element that manages an add to cart button.
 *
 * @typedef {object} AddToCartRefs
 * @property {HTMLButtonElement} addToCartButton - The add to cart button.
 * @extends Component<AddToCartRefs>
 */
export class AddToCartComponent extends Component {
  requiredRefs = ['addToCartButton'];

  /** @type {number | undefined} */
  #animationTimeout;

  /** @type {number | undefined} */
  #cleanupTimeout;

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('pointerenter', this.#preloadImage);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
    if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);
    this.removeEventListener('pointerenter', this.#preloadImage);
  }

  /**
   * Disables the add to cart button.
   */
  disable() {
    this.refs.addToCartButton.disabled = true;
  }

  /**
   * Enables the add to cart button.
   */
  enable() {
    this.refs.addToCartButton.disabled = false;
  }

  /**
   * Handles the click event for the add to cart button.
   * @param {MouseEvent & {target: HTMLElement}} event - The click event.
   */
 handleClick(event) {
    const isValid = this.validation();
    if (!isValid) {
      event.preventDefault();
      event.stopPropagation();
      return; // stop here, no animation
    }

    this.animateAddToCart();
    if (!event.target.closest('.quick-add-modal')) this.#animateFlyToCart();
  }

  #preloadImage = () => {
    const image = this.dataset.productVariantMedia;

    if (!image) return;

    preloadImage(image);
  };

  /**
   * Animates the fly to cart animation.
   */
  #animateFlyToCart() {
    const { addToCartButton } = this.refs;
    const cartIcon = document.querySelector('.header-actions__cart-icon');

    const image = this.dataset.productVariantMedia;

    if (!cartIcon || !addToCartButton || !image) return;

    const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

    flyToCartElement.style.setProperty('background-image', `url(${image})`);
    flyToCartElement.source = addToCartButton;
    flyToCartElement.destination = cartIcon;

    document.body.appendChild(flyToCartElement);
  }

  /**
   * Animates the add to cart button.
   */
  animateAddToCart() {
    const { addToCartButton } = this.refs;

    if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
    if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);

    if (!addToCartButton.classList.contains('atc-added')) {
      addToCartButton.classList.add('atc-added');
    }

    this.#animationTimeout = setTimeout(() => {
      this.#cleanupTimeout = setTimeout(() => {
        this.refs.addToCartButton.classList.remove('atc-added');
      }, 10);
    }, ADD_TO_CART_TEXT_ANIMATION_DURATION);
  }

// OLD CODE OF VALIDATION
  //  validation() {
  //   let isValid = true;
  //   const productCustomForm = document.querySelector("custom-fields-wrapper");
  //   if (!productCustomForm) return true; // no custom fields = skip validation

  //   // Dropdown 1
  //   const dd1 = productCustomForm.querySelector('select[name="accounting_code"]') ||  document.querySelector("[name='name']");
  //   const dd1Error = productCustomForm.querySelector(".validation_1");
  //   if (dd1 && !dd1.value) {
  //     dd1Error?.classList.remove("hidden");
  //     isValid = false;
  //   } else {
  //     dd1Error?.classList.add("hidden");
  //   }

  //   // Dropdown 2
  //   const dd2 = productCustomForm.querySelector('select[name="accounting_class"]') || document.querySelector("[name='title']");
  //   const dd2Error = productCustomForm.querySelector(".validation_2");
  //   if (dd2 && !dd2.value) {
  //     dd2Error?.classList.remove("hidden");
  //     isValid = false;
  //   } else {
  //     dd2Error?.classList.add("hidden");
  //   }

  //    // Dropdown 3
  //   const dd5 = productCustomForm.querySelector('select[name="charge_budget_option"]');
  //   const dd5Error = productCustomForm.querySelector(".validation_5");
  //   if (dd5 && !dd5.value) {
  //     dd5Error?.classList.remove("hidden");
  //     isValid = false;
  //   } else {
  //     dd5Error?.classList.add("hidden");
  //   }

  //   // Textarea 1
  //   const ta1 = productCustomForm.querySelector('textarea[name="charge_budget"]') || document.querySelector("[name='cell']");
  //   const ta1Error = productCustomForm.querySelector(".validation_3");
  //   if (ta1 && !ta1.value.trim()) {
  //     ta1Error?.classList.remove("hidden");
  //     isValid = false;
  //   } else {
  //     ta1Error?.classList.add("hidden");
  //   }

  //   // Textarea 2
  //   const ta2 = productCustomForm.querySelector('textarea[name="restricted_fund"]') || document.querySelector("[name='email']");
  //   const ta2Error = productCustomForm.querySelector(".validation_4");
  //   if (ta2 && !ta2.value.trim()) {
  //     ta2Error?.classList.remove("hidden");
  //     isValid = false;
  //   } else {
  //     ta2Error?.classList.add("hidden");
  //   }

  //   return isValid;
  // }
// end


validation() {
  let isValid = true;
  const productCustomForms = document.querySelectorAll("custom-fields-wrapper");
  if (!productCustomForms.length) return true; // no custom fields = skip validation

  let template = document.querySelector('[data-template-name]').dataset.templateName;

  productCustomForms.forEach(formWrapper => {
    if (template == "business-cards" || template == "volunteer-business-card" || template == "mailing-label" || template == "nametag") {
      // Dropdown 1
      const dd1 = formWrapper.querySelector('select[name="accounting_code"]') || document.querySelector("[name='name']");
      const dd1Error = formWrapper.querySelector(".validation_1");
      if (dd1 && !dd1.value) {
        dd1Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd1Error?.classList.add("hidden");
      }
      if (dd1) {
        if (dd1.tagName === "SELECT") {
          dd1.addEventListener("change", () => dd1Error?.classList.add("hidden"));
        } else {
          dd1.addEventListener("input", () => dd1Error?.classList.add("hidden"));
        }
      }

      // Dropdown 2
      const dd2 = formWrapper.querySelector('select[name="accounting_class"]') || document.querySelector("[name='title']");
      const dd2Error = formWrapper.querySelector(".validation_2");
      if (dd2 && !dd2.value) {
        dd2Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd2Error?.classList.add("hidden");
      }
            if (dd2) {
        if (dd2.tagName === "SELECT") {
          dd2.addEventListener("change", () => dd2Error?.classList.add("hidden"));
        } else {
          dd2.addEventListener("input", () => dd2Error?.classList.add("hidden"));
        }
      }

      // Dropdown 3
      const dd5 = formWrapper.querySelector('select[name="charge_budget_option"]');
      const dd5Error = formWrapper.querySelector(".validation_5");
      if (dd5 && !dd5.value) {
        dd5Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd5Error?.classList.add("hidden");
      }
      dd5?.addEventListener("change", () => dd5Error?.classList.add("hidden"));

      // dropdown 4
      const dd6 = formWrapper.querySelector('select[name="satellite_office_address"]')
      const dd6Error = formWrapper.querySelector(".validation_6");
      if (dd6 && !dd6.value) {
        dd6Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd6Error?.classList.add("hidden");
      }
      if (dd6) {
        if (dd6.tagName === "SELECT") {
          dd6.addEventListener("change", () => dd6Error?.classList.add("hidden"));
        }
      }


      // Textarea 1
      const ta1 = formWrapper.querySelector('textarea[name="charge_budget"]') || document.querySelector("[name='cell']");
      const ta1Error = formWrapper.querySelector(".validation_3");
      if (ta1 && !ta1.value.trim()) {
        ta1Error?.classList.remove("hidden");
        isValid = false;
      } else {
        ta1Error?.classList.add("hidden");
      }
      ta1?.addEventListener("input", () => ta1Error?.classList.add("hidden"));

      // Textarea 2
      const ta2 = formWrapper.querySelector('textarea[name="restricted_fund"]');
      const ta2Error = formWrapper.querySelector(".validation_4");
      if (ta2 && !ta2.value.trim()) {
        ta2Error?.classList.remove("hidden");
        isValid = false;
      } else {
        ta2Error?.classList.add("hidden");
      }
      ta2?.addEventListener("input", () => ta2Error?.classList.add("hidden"));

      if (template != "volunteer-business-card") {
        const ta3 = formWrapper.querySelector("[name='email']");
        const ta3Error = formWrapper.querySelector(".validation_4");
        if (ta2 && !ta3.value.trim()) {
          ta3Error?.classList.remove("hidden");
          isValid = false;
        } else {
          ta3Error?.classList.add("hidden");
        }
        ta3?.addEventListener("input", () => ta3Error?.classList.add("hidden"));
      }

      const mailingName = formWrapper.querySelector("[name='mailing_label_name']");
      const mailingNameError = formWrapper.querySelector(".validation_1");
      if (mailingName && !mailingName.value.trim()) {
        mailingNameError?.classList.remove("hidden");
        isValid = false;
      } else if (mailingName) {
        mailingNameError?.classList.add("hidden");
      }
      mailingName?.addEventListener("input", () => mailingNameError?.classList.add("hidden"));

      const mailingAddress = formWrapper.querySelector("[name='mailing_label_address']");
      const mailingAddressError = formWrapper.querySelector(".validation_2");
      if (mailingAddress && !mailingAddress.value.trim()) {
        mailingAddressError?.classList.remove("hidden");
        isValid = false;
      } else if (mailingAddress) {
        mailingAddressError?.classList.add("hidden");
      }
      mailingAddress?.addEventListener("input", () => mailingAddressError?.classList.add("hidden"));

      const nametag = formWrapper.querySelector("[name='nametag_name']");
      const nametagError = formWrapper.querySelector(".validation_1");
      if (nametag && !nametag.value.trim()) {
        nametagError?.classList.remove("hidden");
        isValid = false;
      } else if (nametag) {
        nametagError?.classList.add("hidden");
      }
      nametag?.addEventListener("input", () => nametagError?.classList.add("hidden"));

    } else {
      // Same validation for non-business-cards
      const dd1 = formWrapper.querySelector('select[name="accounting_code"]') || document.querySelector("[name='name']");
      const dd1Error = formWrapper.querySelector(".validation_1");
      if (dd1 && !dd1.value) {
        dd1Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd1Error?.classList.add("hidden");
      }
      dd1?.addEventListener("change", () => dd1Error?.classList.add("hidden"));

      const dd2 = formWrapper.querySelector('select[name="accounting_class"]') || document.querySelector("[name='title']");
      const dd2Error = formWrapper.querySelector(".validation_2");
      if (dd2 && !dd2.value) {
        dd2Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd2Error?.classList.add("hidden");
      }
      dd2?.addEventListener("change", () => dd2Error?.classList.add("hidden"));

      const dd5 = formWrapper.querySelector('select[name="charge_budget_option"]');
      const dd5Error = formWrapper.querySelector(".validation_5");
      if (dd5 && !dd5.value) {
        dd5Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd5Error?.classList.add("hidden");
      }
      dd5?.addEventListener("change", () => dd5Error?.classList.add("hidden"));

      // dropdown 4
        const dd6 = formWrapper.querySelector('select[name="satellite_office_address"]')
      const dd6Error = formWrapper.querySelector(".validation_6");
      if (dd6 && !dd6.value) {
        dd6Error?.classList.remove("hidden");
        isValid = false;
      } else {
        dd6Error?.classList.add("hidden");
      }
      if (dd6) {
        if (dd6.tagName === "SELECT") {
          dd6.addEventListener("change", () => dd1Error?.classList.add("hidden"));
        }
      }

      const ta1 = formWrapper.querySelector('textarea[name="charge_budget"]') || document.querySelector("[name='cell']");
      const ta1Error = formWrapper.querySelector(".validation_3");
      if (ta1 && !ta1.value.trim()) {
        ta1Error?.classList.remove("hidden");
        isValid = false;
      } else {
        ta1Error?.classList.add("hidden");
      }
      ta1?.addEventListener("input", () => ta1Error?.classList.add("hidden"));
      if (condition) {
        
      }
      const ta2 = formWrapper.querySelector('textarea[name="restricted_fund"]') || document.querySelector("[name='email']");
      const ta2Error = formWrapper.querySelector(".validation_4");
      if (ta2 && !ta2.value.trim()) {
        ta2Error?.classList.remove("hidden");
        isValid = false;
      } else {
        ta2Error?.classList.add("hidden");
      }
      ta2?.addEventListener("input", () => ta2Error?.classList.add("hidden"));
    }
  });

  return isValid;
}

}

if (!customElements.get('add-to-cart-component')) {
  customElements.define('add-to-cart-component', AddToCartComponent);
}

/**
 * A custom element that manages a product form.
 *
 * @typedef {object} ProductFormRefs
 * @property {HTMLInputElement} variantId - The form input for submitting the variant ID.
 * @property {AddToCartComponent | undefined} addToCartButtonContainer - The add to cart button container element.
 * @property {HTMLElement | undefined} addToCartTextError - The add to cart text error.
 * @property {HTMLElement | undefined} acceleratedCheckoutButtonContainer - The accelerated checkout button container element.
 * @property {HTMLElement} liveRegion - The live region.
 *
 * @extends Component<ProductFormRefs>
 */
class ProductFormComponent extends Component {
  requiredRefs = ['variantId', 'liveRegion'];
  #abortController = new AbortController();

  /** @type {number | undefined} */
  #timeout;

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
    target?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
  }

  /**
   * Handles the submit event for the product form.
   *
   * @param {Event} event - The submit event.
   */
  handleSubmit(event) {
    const { addToCartTextError } = this.refs;
    // Stop default behaviour from the browser
    event.preventDefault();

    if (this.#timeout) clearTimeout(this.#timeout);

    // Check if the add to cart button is disabled and do an early return if it is
    if (this.refs.addToCartButtonContainer?.refs.addToCartButton?.getAttribute('disabled') === 'true') return;

    // Send the add to cart information to the cart
    const form = this.querySelector('form');

    if (!form) throw new Error('Product form element missing');

    const formData = new FormData(form);

    this.customFormData(formData);

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    let cartItemComponentsSectionIds = [];
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        cartItemComponentsSectionIds.push(item.dataset.sectionId);
      }
      formData.append('sections', cartItemComponentsSectionIds.join(','));
    });

    const fetchCfg = fetchConfig('javascript', { body: formData });

    fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'text/html',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          window.dispatchEvent(new CartErrorEvent(this.id, response.message));

          if (!addToCartTextError) return;
          addToCartTextError.classList.remove('hidden');

          // Reuse the text node if the user is spam-clicking
          const textNode = addToCartTextError.childNodes[2];
          if (textNode) {
            textNode.textContent = response.message;
          } else {
            const newTextNode = document.createTextNode(response.message);
            addToCartTextError.appendChild(newTextNode);
          }

          // Create or get existing error live region for screen readers
          this.#setLiveRegionText(response.message);

          this.#timeout = setTimeout(() => {
            if (!addToCartTextError) return;
            addToCartTextError.classList.add('hidden');

            // Clear the announcement
            this.#clearLiveRegionText();
          }, 10000);

          // When we add more than the maximum amount of items to the cart, we need to dispatch a cart update event
          // because our back-end still adds the max allowed amount to the cart.
          this.dispatchEvent(
            new CartAddEvent({}, this.id, {
              didError: true,
              source: 'product-form-component',
              itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
              productId: this.dataset.productId,
            })
          );

          return;
        } else {
          const id = formData.get('id');

          if (addToCartTextError) {
            addToCartTextError.classList.add('hidden');
            addToCartTextError.removeAttribute('aria-live');
          }

          if (!id) throw new Error('Form ID is required');

          // Add aria-live region to inform screen readers that the item was added
          if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
            const addToCartButton = this.refs.addToCartButtonContainer.refs.addToCartButton;
            const addedTextElement = addToCartButton.querySelector('.add-to-cart-text--added');
            const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;

            this.#setLiveRegionText(addedText);

            setTimeout(() => {
              this.#clearLiveRegionText();
            }, 5000);
          }

          this.dispatchEvent(
            new CartAddEvent({}, id.toString(), {
              source: 'product-form-component',
              itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
              productId: this.dataset.productId,
              sections: response.sections,
            })
          );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        // add more thing to do in here if needed.
        cartPerformance.measureFromEvent('add:user-action', event);
      });
  }

customFormData(formData) {
    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, '');
    const uniqueId = `${timestamp}`;

    let template = document.querySelector('[data-template-name]')?.dataset.templateName; 
       
    if (template == "business-cards") {
      
    let product = document.querySelector('[data-product-name]')?.dataset.productName || "Unknown Product";
            
        const productProperties = [
          { key: "ProductName", val: product },
          { key: "Name", val: document.querySelector("[name='name']")?.value || "" },
          { key: "Email", val: document.querySelector("[name='email']")?.value || "" },
          { key: "Title", val: document.querySelector("[name='title']")?.value || "" },
          { key: "Cell", val: document.querySelector("[name='cell']")?.value || "" },
          { key: "Satellite Office Address",val: document.querySelector("[name='satellite_office_address']")?.value || "" },
        ];
      
        productProperties.forEach(item => {
          formData.append(`properties[${item.key}]`, item.val);
        });
      
        const chargeBudgetValue = 
          document.querySelector("[name='charge_budget']")?.value ||
          document.querySelector("[name='charge_budget_option']")?.value || 
          "";
      
        const attributeFields = [
          { key: "ProductName", label:"ProductName" , val: product},
          { key: "accounting_code", label: "Accounting Code", val: document.querySelector("[name='accounting_code']")?.value || "" },
          { key: "accounting_class", label: "Accounting Class", val: document.querySelector("[name='accounting_class']")?.value || "" },
          { key: "charge_budget", label: "Charge Budget", val: chargeBudgetValue },
          { key: "restricted_fund", label: "Restricted Fund", val: document.querySelector("[name='restricted_fund']")?.value || "" }
        ];
      
        const attributePayload = attributeFields
          .filter(item => item.val.trim() !== "")
          .reduce((acc, item) => {
            acc[item.key] = `${item.label}: ${item.val}`;
            return acc;
          }, {});
        
        formData.append("properties[_unique_id]", uniqueId);
        
        const formattedString = Object.values(attributePayload).join(" | ");
        
        formData.delete(`attributes[${uniqueId}]`);
        if (formattedString) {
          formData.append(`attributes[${uniqueId}]`, formattedString);
        }
      
      
    }
    else if (template == "mailing-label") {
      
    let product = document.querySelector('[data-product-name]')?.dataset.productName || "Unknown Product";
            
        const productProperties = [
          { key: "ProductName", val: product },
          { key: "Mailing_label_name", val: document.querySelector("[name='mailing_label_name']")?.value || "" },
          { key: "Mailing_label_address", val: document.querySelector("[name='mailing_label_address']")?.value || "" },
        ];
      
        productProperties.forEach(item => {
          formData.append(`properties[${item.key}]`, item.val);
        });
      
        const chargeBudgetValue = 
          document.querySelector("[name='charge_budget']")?.value ||
          document.querySelector("[name='charge_budget_option']")?.value || 
          "";
      
        const attributeFields = [
          { key: "ProductName", label:"ProductName" , val: product},
          { key: "accounting_code", label: "Accounting Code", val: document.querySelector("[name='accounting_code']")?.value || "" },
          { key: "accounting_class", label: "Accounting Class", val: document.querySelector("[name='accounting_class']")?.value || "" },
          { key: "charge_budget", label: "Charge Budget", val: chargeBudgetValue },
          { key: "restricted_fund", label: "Restricted Fund", val: document.querySelector("[name='restricted_fund']")?.value || "" }
        ];
      
        const attributePayload = attributeFields
          .filter(item => item.val.trim() !== "")
          .reduce((acc, item) => {
            acc[item.key] = `${item.label}: ${item.val}`;
            return acc;
          }, {});
        
        formData.append("properties[_unique_id]", uniqueId);
        
        const formattedString = Object.values(attributePayload).join(" | ");
        
        formData.delete(`attributes[${uniqueId}]`);
        if (formattedString) {
          formData.append(`attributes[${uniqueId}]`, formattedString);
        }
      
      
    }
    else if (template == "nametag") {
      
    let product = document.querySelector('[data-product-name]')?.dataset.productName || "Unknown Product";
            
        const productProperties = [
          { key: "ProductName", val: product },
          { key: "Nametag_name", val: document.querySelector("[name='nametag_name']")?.value || "" },
        ];
      
        productProperties.forEach(item => {
          formData.append(`properties[${item.key}]`, item.val);
        });
      
        const chargeBudgetValue = 
          document.querySelector("[name='charge_budget']")?.value ||
          document.querySelector("[name='charge_budget_option']")?.value || 
          "";
      
        const attributeFields = [
          { key: "ProductName", label:"ProductName" , val: product},
          { key: "accounting_code", label: "Accounting Code", val: document.querySelector("[name='accounting_code']")?.value || "" },
          { key: "accounting_class", label: "Accounting Class", val: document.querySelector("[name='accounting_class']")?.value || "" },
          { key: "charge_budget", label: "Charge Budget", val: chargeBudgetValue },
          { key: "restricted_fund", label: "Restricted Fund", val: document.querySelector("[name='restricted_fund']")?.value || "" }
        ];
      
        const attributePayload = attributeFields
          .filter(item => item.val.trim() !== "")
          .reduce((acc, item) => {
            acc[item.key] = `${item.label}: ${item.val}`;
            return acc;
          }, {});
        
        formData.append("properties[_unique_id]", uniqueId);
        
        const formattedString = Object.values(attributePayload).join(" | ");
        
        formData.delete(`attributes[${uniqueId}]`);
        if (formattedString) {
          formData.append(`attributes[${uniqueId}]`, formattedString);
        }
      
      
    }
    else if(template == "volunteer-business-card")
    {      
         let product = document.querySelector('[data-product-name]')?.dataset.productName || "Unknown Product";
            
        const productProperties = [
          { key: "ProductName", val: product },
          { key: "Name", val: document.querySelector("[name='name']")?.value || "" },
          { key: "Email", val: document.querySelector("[name='email']")?.value || "" },
          { key: "Title", val: document.querySelector("[name='title']")?.value || "" },
          { key: "Cell", val: document.querySelector("[name='cell']")?.value || "" },
          { key: "Satellite Office Address",val: document.querySelector("[name='satellite_office_address']")?.value || "" },
          { key : "Volunteer_name",val: document.querySelector("[name='volunteer_name']")?.value || ""},
          { key : "Volunteer_title",val: document.querySelector("[name='volunteer_title']")?.value || ""},
          { key : "Volunteer_address",val: document.querySelector("[name='volunteer_address']")?.value || ""},
          { key : "Volunteer_phone",val: document.querySelector("[name='volunteer_phone']")?.value || ""},
        ];
      
        productProperties.forEach(item => {
          formData.append(`properties[${item.key}]`, item.val);
        });
      
        const chargeBudgetValue = 
          document.querySelector("[name='charge_budget']")?.value ||
          document.querySelector("[name='charge_budget_option']")?.value || 
          "";
      
        const attributeFields = [
          { key: "ProductName", label:"ProductName" , val: product},
          { key: "accounting_code", label: "Accounting Code", val: document.querySelector("[name='accounting_code']")?.value || "" },
          { key: "accounting_class", label: "Accounting Class", val: document.querySelector("[name='accounting_class']")?.value || "" },
          { key: "charge_budget", label: "Charge Budget", val: chargeBudgetValue },
          { key: "restricted_fund", label: "Restricted Fund", val: document.querySelector("[name='restricted_fund']")?.value || "" }
        ];
      
        const attributePayload = attributeFields
          .filter(item => item.val.trim() !== "")
          .reduce((acc, item) => {
            acc[item.key] = `${item.label}: ${item.val}`;
            return acc;
          }, {});
        
        formData.append("properties[_unique_id]", uniqueId);
        
        const formattedString = Object.values(attributePayload).join(" | ");
        
        formData.delete(`attributes[${uniqueId}]`);
        if (formattedString) {
          formData.append(`attributes[${uniqueId}]`, formattedString);
        }
    } 
    else {
       let product = document.querySelector('[data-product-name]').dataset.productName;    
    let fieldsvalue_1 = document.querySelector(".field_1")?.innerText || "accounting_code";
    let fieldsvalue_2 = document.querySelector(".field_2")?.innerText || "accounting_class";
    let fieldsvalue_3 = document.querySelector(".field_3")?.innerText || "charge_budget";
    let fieldsvalue_4 = document.querySelector(".field_4")?.innerText || "restricted_fund";
    let fieldsvalue_5 = document.querySelector(".field_5")?.innerText || "charge_budget";
    let fieldsvalue_6 = document.querySelector(".field_6")?.innerText || "satellite_office_address";

    // Build payload only if value is non-empty
    const allFields = [
      { key: "ProductName", val: product},
      { key: fieldsvalue_1, val: document.querySelector("[name='accounting_code']")?.value ||  document.querySelector("[name='name']")?.value || "" },
      { key: fieldsvalue_2, val: document.querySelector("[name='accounting_class']")?.value || document.querySelector("[name='title']")?.value || "" },
      { key: fieldsvalue_5, val: document.querySelector("[name='charge_budget_option']")?.value ||  "" },
      { key: fieldsvalue_6, val: document.querySelector("[name='satellite_office_address']")?.value ||  "" },
      { key: fieldsvalue_3, val: document.querySelector("[name='charge_budget']")?.value || document.querySelector("[name='cell']")?.value || "" },
      { key: fieldsvalue_4, val: document.querySelector("[name='restricted_fund']")?.value || document.querySelector("[name='email']")?.value || "" },
    ];

    // Filter out empty values
    const attributePayload = allFields
      .filter(item => item.val.trim() !== "")
      .reduce((acc, item) => {
        acc[item.key] = item.val;
        return acc;
      }, {});

    // Ensure line item unique
    formData.append("properties[_unique_id]", uniqueId);

    // Convert object → string
    const formattedString = Object.entries(attributePayload)
      .map(([key, val]) => `${key}: ${val}`)
      .join(" | ");

    // Save as Shopify order attribute (only if we have something to save)
    formData.delete(`attributes[${uniqueId}]`);
    if (formattedString) {
      formData.append(`attributes[${uniqueId}]`, formattedString);
    }
  }

}

// OLD CODE 
  // customFormData(formData) {
  //   const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, '');
  //   const uniqueId = `${timestamp}`;

  //   //  get label text (fallback to default if missing)
  //   let product = document.querySelector('[data-product-name]').dataset.productName;    
  //   let fieldsvalue_1 = document.querySelector(".field_1")?.innerText || "accounting_code";
  //   let fieldsvalue_2 = document.querySelector(".field_2")?.innerText || "accounting_class";
  //   let fieldsvalue_3 = document.querySelector(".field_3")?.innerText || "charge_budget";
  //   let fieldsvalue_4 = document.querySelector(".field_4")?.innerText || "restricted_fund";
  //   let fieldsvalue_5 = document.querySelector(".field_5")?.innerText || "charge_budget";


  //   // Build payload only if value is non-empty
  //   const allFields = [
  //     { key: "ProductName", val: product},
  //     { key: fieldsvalue_1, val: document.querySelector("[name='accounting_code']")?.value ||  document.querySelector("[name='name']")?.value || "" },
  //     { key: fieldsvalue_2, val: document.querySelector("[name='accounting_class']")?.value || document.querySelector("[name='title']")?.value || "" },
  //     { key: fieldsvalue_5, val: document.querySelector("[name='charge_budget_option']")?.value ||  "" },
  //     { key: fieldsvalue_3, val: document.querySelector("[name='charge_budget']")?.value || document.querySelector("[name='cell']")?.value || "" },
  //     { key: fieldsvalue_4, val: document.querySelector("[name='restricted_fund']")?.value || document.querySelector("[name='email']")?.value || "" },
  //   ];

  //   // Filter out empty values
  //   const attributePayload = allFields
  //     .filter(item => item.val.trim() !== "")
  //     .reduce((acc, item) => {
  //       acc[item.key] = item.val;
  //       return acc;
  //     }, {});

  //   // Ensure line item unique
  //   formData.append("properties[_unique_id]", uniqueId);

  //   // Convert object → string
  //   const formattedString = Object.entries(attributePayload)
  //     .map(([key, val]) => `${key}: ${val}`)
  //     .join(" | ");

  //   // Save as Shopify order attribute (only if we have something to save)
  //   formData.delete(`attributes[${uniqueId}]`);
  //   if (formattedString) {
  //     formData.append(`attributes[${uniqueId}]`, formattedString);
  //   }
  // }


  /**
   * @param {*} text
   */
  #setLiveRegionText(text) {
    const liveRegion = this.refs.liveRegion;
    liveRegion.textContent = text;
  }

  #clearLiveRegionText() {
    const liveRegion = this.refs.liveRegion;
    liveRegion.textContent = '';
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const { variantId, addToCartButtonContainer } = this.refs;

    const currentAddToCartButton = addToCartButtonContainer?.refs.addToCartButton;
    const newAddToCartButton = event.detail.data.html.querySelector('[ref="addToCartButton"]');

    if (!currentAddToCartButton) return;

    // Update the button state
    if (event.detail.resource == null || event.detail.resource.available == false) {
      addToCartButtonContainer.disable();
      this.refs.acceleratedCheckoutButtonContainer?.setAttribute('hidden', 'true');
    } else {
      addToCartButtonContainer.enable();
      this.refs.acceleratedCheckoutButtonContainer?.removeAttribute('hidden');
    }

    // Update the add to cart button text and icon
    if (newAddToCartButton) {
      morph(currentAddToCartButton, newAddToCartButton);
    }

    // Update the variant ID
    variantId.value = event.detail.resource.id ?? '';

    // Set the data attribute for the add to cart button to the product variant media if it exists
    if (event.detail.resource) {
      const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
      productVariantMedia &&
        addToCartButtonContainer?.setAttribute('data-product-variant-media', productVariantMedia + '&width=100');
    }
  };

  /**
   * Disable the add to cart button while the UI is updating before #onVariantUpdate is called.
   * Accelerated checkout button is also disabled via its own event listener not exposed to the theme.
   */
  #onVariantSelected = () => {
    this.refs.addToCartButtonContainer?.disable();
  };
}

if (!customElements.get('product-form-component')) {
  customElements.define('product-form-component', ProductFormComponent);
}

class FlyToCart extends HTMLElement {
  /** @type {Element} */
  source;

  /** @type {Element} */
  destination;

  connectedCallback() {
    this.#animate();
  }

  #animate() {
    const rect = this.getBoundingClientRect();
    const sourceRect = this.source.getBoundingClientRect();
    const destinationRect = this.destination.getBoundingClientRect();

    //Define bezier curve points
    // Maybe add half of the size of the flying thingy to the x and y to make it center properly
    const offset = {
      x: rect.width / 2,
      y: rect.height / 2,
    };
    const startPoint = {
      x: sourceRect.left + sourceRect.width / 2 - offset.x,
      y: sourceRect.top + sourceRect.height / 2 - offset.y,
    };

    const endPoint = {
      x: destinationRect.left + destinationRect.width / 2 - offset.x,
      y: destinationRect.top + destinationRect.height / 2 - offset.y,
    };

    //Calculate the control points
    const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 }; // Go up 200px
    const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 }; // Go left 300px and up 100px

    //Animation variables
    /** @type {number | null} */
    let startTime = null;
    const duration = 600; // 600ms

    this.style.opacity = '1';

    /**
     * Animates the flying thingy along the bezier curve.
     * @param {number} currentTime - The current time.
     */
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Calculate current position along the bezier curve
      const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

      //Update the position of the flying thingy
      this.style.setProperty('--x', `${position.x}px`);
      this.style.setProperty('--y', `${position.y}px`);

      // Scale down as it approaches the cart
      const scale = 1 - progress * 0.5;
      this.style.setProperty('--scale', `${scale}`);

      //Continue the animation if not finished
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        //Fade out the flying thingy
        this.style.opacity = '0';
        onAnimationEnd(this, () => this.remove());
      }
    };

    // Position the flying thingy back to the start point
    this.style.setProperty('--x', `${startPoint.x}px`);
    this.style.setProperty('--y', `${startPoint.y}px`);

    //Start the animation
    requestAnimationFrame(animate);
  }
}

/**
 * Calculates a point on a cubic Bézier curve.
 * @param {number} t - The parameter value (0 <= t <= 1).
 * @param {{x: number, y: number}} p0 - The starting point (x, y).
 * @param {{x: number, y: number}} p1 - The first control point (x, y).
 * @param {{x: number, y: number}} p2 - The second control point (x, y).
 * @param {{x: number, y: number}} p3 - The ending point (x, y).
 * @returns {{x: number, y: number}} The point on the curve.
 */
function bezierPoint(t, p0, p1, p2, p3) {
  const cX = 3 * (p1.x - p0.x);
  const bX = 3 * (p2.x - p1.x) - cX;
  const aX = p3.x - p0.x - cX - bX;

  const cY = 3 * (p1.y - p0.y);
  const bY = 3 * (p2.y - p1.y) - cY;
  const aY = p3.y - p0.y - cY - bY;

  const x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x;
  const y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y;

  return { x, y };
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}
